// Generated by ReScript, PLEASE EDIT WITH CARE


function isErrored(value) {
  switch (value) {
    case "Pristine" :
    case "Valid" :
      return false;
    case "Errored" :
      return true;
  }
}

function isValid(value) {
  switch (value) {
    case "Valid" :
      return true;
    case "Pristine" :
    case "Errored" :
      return false;
  }
}

function isPristine(value) {
  switch (value) {
    case "Pristine" :
      return true;
    case "Valid" :
    case "Errored" :
      return false;
  }
}

export {
  isErrored,
  isValid,
  isPristine,
}
/* No side effect */
